var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUzbekistan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.566625 8.34788C0.199031 9.4995 -4.68667e-05 10.7264 8.276e-09 11.9999C-4.68667e-05 13.2735 0.199078 14.5005 0.566672 15.6521L12 16.1739L23.4333 15.6522C23.8009 14.5005 24 13.2735 24 12C24 10.7264 23.8009 9.4995 23.4333 8.34783L12 7.82611L0.566625 8.34788Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4333 8.34786L12 7.82614L0.566592 8.34786C0.457654 8.6893 0.363857 9.03744 0.285248 9.39134H23.7145C23.636 9.03739 23.5422 8.6892 23.4333 8.34786Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2854 14.6086C0.363916 14.9625 0.457713 15.3106 0.56665 15.6521L0.567775 15.6521L11.9999 16.1738L23.4333 15.6521C23.5422 15.3107 23.636 14.9625 23.7146 14.6086H0.2854Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C17.3538 24 21.8881 20.4936 23.4333 15.6521H0.566681C2.11192 20.4935 6.64623 24 12 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.10356e-05C6.64617 0.000107911 2.11195 3.5065 0.56662 8.34789L23.4332 8.34794C21.8881 3.50645 17.3538 1.41606e-05 11.9999 6.10356e-05Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48373 4.95655C5.48373 3.83262 6.27362 2.89372 7.32845 2.66337C7.16635 2.62794 6.99812 2.60876 6.82534 2.60876C5.52868 2.60876 4.47751 3.65989 4.47751 4.95659C4.47751 6.2533 5.52859 7.30442 6.82534 7.30442C6.99812 7.30442 7.16631 7.2852 7.32845 7.24981C6.27366 7.01937 5.48373 6.08047 5.48373 4.95655Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71613 6.02374L8.87503 6.51288H9.38935L8.97328 6.81523L9.13219 7.30437L8.71613 7.00207L8.29997 7.30437L8.45893 6.81523L8.04282 6.51288H8.55713L8.71613 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3577 6.02374L10.5167 6.51288H11.031L10.6149 6.81523L10.7738 7.30437L10.3577 7.00207L9.94159 7.30437L10.1005 6.81523L9.68448 6.51288H10.1987L10.3577 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 6.02374L12.1582 6.51288H12.6726L12.2565 6.81523L12.4154 7.30437L11.9993 7.00207L11.5831 7.30437L11.7421 6.81523L11.326 6.51288H11.8403L11.9993 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6409 6.02374L13.7999 6.51288H14.3141L13.8981 6.81523L14.057 7.30437L13.6409 7.00207L13.2247 7.30437L13.3837 6.81523L12.9676 6.51288H13.4819L13.6409 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2825 6.02374L15.4414 6.51288H15.9557L15.5397 6.81523L15.6986 7.30437L15.2825 7.00207L14.8664 7.30437L15.0253 6.81523L14.6093 6.51288H15.1235L15.2825 6.02374Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3577 4.31622L10.5167 4.80532H11.031L10.6149 5.10771L10.7738 5.5968L10.3577 5.2945L9.94159 5.5968L10.1005 5.10771L9.68448 4.80532H10.1987L10.3577 4.31622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 4.31622L12.1582 4.80532H12.6726L12.2565 5.10771L12.4154 5.5968L11.9993 5.2945L11.5831 5.5968L11.7421 5.10771L11.326 4.80532H11.8403L11.9993 4.31622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6409 4.31622L13.7999 4.80532H14.3141L13.8981 5.10771L14.057 5.5968L13.6409 5.2945L13.2247 5.5968L13.3837 5.10771L12.9676 4.80532H13.4819L13.6409 4.31622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2825 4.31622L15.4414 4.80532H15.9557L15.5397 5.10771L15.6986 5.5968L15.2825 5.2945L14.8664 5.5968L15.0253 5.10771L14.6093 4.80532H15.1235L15.2825 4.31622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 2.60867L12.1582 3.09786H12.6726L12.2565 3.40016L12.4154 3.88934L11.9993 3.58705L11.5831 3.88934L11.7421 3.40016L11.326 3.09786H11.8403L11.9993 2.60867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6409 2.60867L13.7999 3.09786H14.3141L13.8981 3.40016L14.057 3.88934L13.6409 3.58705L13.2247 3.88934L13.3837 3.40016L12.9676 3.09786H13.4819L13.6409 2.60867Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2825 2.60867L15.4414 3.09786H15.9557L15.5397 3.40016L15.6986 3.88934L15.2825 3.58705L14.8664 3.88934L15.0253 3.40016L14.6093 3.09786H15.1235L15.2825 2.60867Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzbekistan);
export default __webpack_public_path__ + "static/media/uzbekistan.cb5a7241f33498d41c677697c247ff3e.svg";
export { ForwardRef as ReactComponent };